import React from 'react'
import Sidebar from './sidebar'
import { Outlet } from 'react-router-dom'

function Dashboarlayout() {
    return (
        <>
        <div className='flex pt-[70px] dark:bg-[#121519]'>
        <Sidebar />
        <div className='sm:ml-[80px] w-[100%] min-h-screen dark:bg-[#121519] '>
        <Outlet />
        </div>
        </div>
        </>
    )
}

export default Dashboarlayout
